var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedPromocode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50097 19.3315L12.501 19.3338C16.6676 19.3357 18.3351 17.6698 18.337 13.5031L18.3393 8.5031C18.3412 4.33644 16.6753 2.669 12.5086 2.66709L7.50863 2.66479C3.34196 2.66288 1.67453 4.32878 1.67261 8.49544L1.67031 13.4954C1.6684 17.6621 3.3343 19.3295 7.50097 19.3315Z",
    fill: "#0090D1",
    stroke: "#0090D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46278 10.998L8.82003 13.3574L13.5472 8.6429",
    fill: "#0090D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46278 10.998L8.82003 13.3574L13.5472 8.6429",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPromocode);
export default __webpack_public_path__ + "static/media/checkedPromocode.19491e3621ecd69eda0ec9eae474e632.svg";
export { ForwardRef as ReactComponent };